import { faPlus } from '@fortawesome/free-solid-svg-icons';
import TopBar from 'components/layout/TopBar';
import { callAxios } from 'components/utils/FormatData';
import { genKey, setStorage } from 'components/utils/Storage';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { isMobile } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { ClipLoader } from 'react-spinners';
import ActionsCommandRenderer from '../../components/agGrid/ActionsCommandRenderer';
import AgGrid from '../../components/agGrid/AgGrid';
import InputNumberRenderer from '../../components/agGrid/InputNumberRenderer';
import MyButton from '../../components/form/MyButton';
import MySelect from '../../components/form/MySelect';
import { URL_API } from '../../constants/settings';
import useWindowSize from '../../hooks/useWindowSize';

const ParamCommand = (props) => {
  const [width, height] = useWindowSize();
  const [loading, setLoading] = useState(true);
  const [typesFamilles, setTypesFamilles] = useState([]);
  const [commandesReferences, setCommandesReferences] = useState([]);
  const [componentHeight, setComponentHeight] = useState(height - 130);
  const [needUpdate, setNeedUpdate] = useState(false);
  const [filters, setFilters] = useState('');
  const [columnDefs] = useState([
    { headerName: 'Libellé', field: 'libelle', flex: 3, minWidth: 300, suppressMovable: true, resizable: true, sortable: true },
    { headerName: 'Commande', field: 'commande', flex: 2, minWidth: 200, suppressMovable: true, resizable: true, sortable: true },
    { headerName: 'Famille', field: 'famille', flex: 1, minWidth: 100, suppressMovable: true, resizable: true, sortable: true, sort: 'asc' },
    { headerName: 'Actions', field: '', flex: 1, minWidth: 100, suppressMovable: true, resizable: true, sortable: false, cellRenderer: 'actionsCommandRenderer', cellRendererParams: { setNeedUpdate: setNeedUpdate, wsStatus: true }, },
  ]);
  const [columnDefsDegraded] = useState([
    { headerName: 'Libellé', field: 'libelle', flex: 3, minWidth: 300, suppressMovable: true, resizable: true, sortable: true },
    { headerName: 'Commande', field: 'commande', flex: 2, minWidth: 200, suppressMovable: true, resizable: true, sortable: true },
    { headerName: 'Famille', field: 'famille', flex: 1, minWidth: 100, suppressMovable: true, resizable: true, sortable: true, sort: 'asc' },
    { headerName: 'Actions', field: '', flex: 1, minWidth: 100, suppressMovable: true, resizable: true, sortable: false, cellRenderer: 'actionsCommandRenderer', cellRendererParams: { setNeedUpdate: setNeedUpdate, wsStatus: false }, },
  ]);
  const [contratGridOptions, setContratGridOptions] = useState({
    suppressCellSelection: true,
    animateRows: true,
  });
  const frameworkComponents = {
    inputNumberRenderer: InputNumberRenderer,
    actionsCommandRenderer: ActionsCommandRenderer,
  };
  const alert = useAlert();
  const history = useHistory();
  const auth = useSelector(state => state["authentification"]);

  useEffect(() => {
    document.title = `SED - Référentiel des commandes`;
    if (auth.profil !== 1 && auth.profil !== 2) {
      alert.error(`Vous n'êtes pas autorisé à accéder à cet écran`);
      history.push('/');
    }
  }, []);
  useEffect(() => {
    setComponentHeight(height - (60 + document.getElementById('component-topbar').clientHeight));
  }, [width, height]);
  useEffect(() => {
    fetchCommandesReferences();
  }, [filters]);
  useEffect(() => {
    if (needUpdate) {
      fetchCommandesReferences();
      setNeedUpdate(false);
    }
  }, [needUpdate]);
  useEffect(() => {
    if (props.wsStatus !== null) {
      fetchFamilyEquipment();
      fetchCommandesReferences();
    }
  }, [props.wsStatus]);

  // Transformation des données
  const transformDatas = (datas) => {
    const formattedDatas = [{ value: '', label: '' }];

    datas.map((d) => {
      formattedDatas.push({ value: d, label: d });
    });

    return formattedDatas;
  };

  // Changement de la famille recherchée
  const changeSelectValue = (v) => {
    setFilters(v.value);
  };

  // Récupération de la liste des familles d'équipement
  const fetchFamilyEquipment = () => {

    callAxios(props.wsStatus, "param_list_familles", { method: 'get', url: URL_API + '/familles' }, setLoading, alert)
      .then((res) => {
        const familyEquipmentDatas = transformDatas(res);
        setTypesFamilles(familyEquipmentDatas);
        setStorage(genKey("param_list_familles"), familyEquipmentDatas);
      });

  };

  // Récupération de la liste des commandes
  const fetchCommandesReferences = () => {
    callAxios(props.wsStatus, "param_list_commandes", { method: 'get', url: URL_API + '/commandes-references', params: { famille: filters } }, setLoading, alert)
      .then((res) => {
        setCommandesReferences(res)
        setStorage(genKey("param_list_commandes"), res);
      });
  };

  const createNewCommande = () => {
    history.push('/parametres/gestion-commandes-references/creation');
  }

  return (
    <div id="parameters" className={!isMobile ? 'panel-contenu' : 'panel-contenu-mobile-tablette'} style={{ height: !isMobile ? height - 110 : height - 60 }}>
      <TopBar title="gestion du référentiel des commandes" className={!isMobile ? 'topbar-contenu' : 'topbar-contenu-mobile-tablette'}
        color={props.params.color}
        buttons={
          <div className="boutons-topbar-contenu">
            {
              props.wsStatus &&
              <MyButton className="classic-button btn-default color-fond-bleu" type="button" labelImportant={isMobile ? "Nouv. commande" : "Nouvelle commande"} href="#"
                iconLeft={{ icon: faPlus, type: 'fontAwesome' }}
                onClick={() => createNewCommande()}
              />
            }
            {
              !props.wsStatus &&
              <MyButton className="classic-button btn-default color-fond-gris" type="button" labelImportant={isMobile ? "Nouv. commande" : "Nouvelle commande"} href="#"
                iconLeft={{ icon: faPlus, type: 'fontAwesome' }}
                styleCss={{ cursor: 'default' }}
              />
            }

            <MySelect
              handleChange={props.wsStatus ? changeSelectValue : null}
              value={filters}
              label={isMobile ? 'Famil. équip.' : "Famille d'équipement"}
              datas={typesFamilles}
              style={{ width: isMobile ? '35vw' : '15vw', marginRight: '25px' }}
              disabled={!props.wsStatus}
            />
          </div>
        } />
      <div className="composant-content-center" style={{ height: componentHeight }}>

        <ClipLoader
          color="#0094ca"
          loading={loading}
          css={'display: flex; position: absolute; top: 45%; left:0; right:0; margin:auto; z-index:150; justify-content: center;'}
          size={50}
        />

        {!loading &&
          <AgGrid
            key={"ag-grid-ws-" + props.wsStatus}
            rowData={commandesReferences}
            columnDefs={props.wsStatus ? columnDefs : columnDefsDegraded}
            height={componentHeight}
            rowHeight={50}
            pagination={false}
            frameworkComponents={frameworkComponents}
            gridOptions={contratGridOptions}
            setGridOptions={setContratGridOptions}
            sortable={false}
            agGridName="ag-grid-overflow"
          />
        }

      </div>
    </div>
  );

};

export default ParamCommand;